import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import {
  FiSearch,
  FiChevronDown,
  FiChevronUp,
  FiChevronRight,
  FiPlay,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PlaylistCard from "../../components/Playlist/PlaylistCard";
import {
  fetchPlaylist,
  fetchFollowingPlaylist,
} from "../../store/playList/actions";

const Dashboard = (props) => {
  const [state, setState] = useState({
    search: "",
    searchResults: [],
  });
  useEffect(() => {
    props.fetchFollowingPlaylist();
    props.fetchPlaylist();
  }, []);
  const handleSearch = () => {
    if (state.search) {
      let searchResults = props.playlist.filter(
        (pl) =>
          pl.title.toLowerCase().includes(state.search.toLowerCase()) ||
          pl?.created_by?.name?.toLowerCase()?.includes(state.search.toLowerCase()) ||
          pl?.created_by?.first_name?.toLowerCase()?.includes(state.search.toLowerCase()) ||
          pl?.created_by?.last_name?.toLowerCase()?.includes(state.search.toLowerCase())
      );
      setState({ ...state, searchResults });
    } else {
      setState({ ...state, searchResults: [] });
    }
  };
  useEffect(() => {
    if (!state.search) {
      setState({ ...state, searchResults: [] });
    }
  }, [state.search]);
  return (
    <div className="dashboard-inner">
      <div className="top container">
        <form action="" className="search-form">
          <div className="search-wrapper">
            <FiSearch className="search-icon" />
            <input
              type="search"
              name=""
              id=""
              className="search-input"
              placeholder="Search"
              value={state.search}
              onChange={(e) => setState({ ...state, search: e.target.value })}
            />
            <div
              className="select"
              onClick={() => {
                handleSearch();
              }}
            >
              <span>Search</span>
              {/* <FiChevronDown /> */}
            </div>
          </div>

          {/* <div className="select-options">
            <div className="item">Item 1</div>
          </div> */}
        </form>
      </div>
      {state.searchResults.length > 0 ? (
        <div className="middle container ">
          <div className="d-flex justify-content-between my-3 border-bottom pb-3">
            <h1 className="h1 font-weight-bold text-black-50 text-uppercase">
              {state.search}
            </h1>
          </div>
          <div className="bg-white wrapper">
            <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
              {state.searchResults.map((item, i) => (
                <PlaylistCard item={item} key={i} />
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="middle container ">
            <div className="d-flex justify-content-between my-3 border-bottom pb-3">
              <h1 className="h1 font-weight-bold text-black-50 ">Top Rated</h1>
              {/* <Link
            className=" btn btn-link  d-flex align-items-center"
            to="/category/top-rated"
          >
            View all <FiChevronRight />
          </Link> */}
            </div>
            <div className="bg-white wrapper">
              <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
                {props.playlist.map((item, i) => (
                  <PlaylistCard item={item} key={i} />
                ))}
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="middle container ">
            <div className="d-flex justify-content-between my-3 border-bottom pb-3">
              <h1 className="h1 font-weight-bold text-black-50 ">
                Popular Courses
              </h1>
              {/* <Link
            className=" btn btn-link  d-flex align-items-center"
            to="/category/popular-courses"
          >
            View all <FiChevronRight />
          </Link> */}
            </div>
            <div className="bg-white wrapper">
              <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
                {props.playlist.map((item, i) => (
                  <PlaylistCard item={item} key={i} />
                ))}
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="middle container ">
            <div className="d-flex justify-content-between my-3 border-bottom pb-3">
              <h1 className="h1 font-weight-bold text-black-50 ">Brand New</h1>
              {/* <Link
            className=" btn btn-link  d-flex align-items-center"
            to="/category/brand-courses"
          >
            View all <FiChevronRight />
          </Link> */}
            </div>
            <div className="bg-white wrapper">
              <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
                {props.playlist.map((item, i) => (
                  <PlaylistCard item={item} key={i} />
                ))}
              </div>
            </div>
          </div>
          {/*  */}
          {/*  */}
          <div className="middle container ">
            <div className="d-flex justify-content-between my-3 border-bottom pb-3">
              <h1 className="h1 font-weight-bold text-black-50 ">
                Recomanded For You
              </h1>
              {/* <Link
            className=" btn btn-link  d-flex align-items-center"
            to="/category/recomanded-courses"
          >
            View all <FiChevronRight />
          </Link> */}
            </div>
            <div className="bg-white wrapper">
              <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
                {props.playlist.map((item, i) => (
                  <PlaylistCard item={item} key={i} />
                ))}
              </div>
            </div>
          </div>
          <div className="middle container ">
            <div className="d-flex justify-content-between my-3 border-bottom pb-3">
              <h1 className="h1 font-weight-bold text-black-50 ">
                Based on who you follow
              </h1>
              {/* <Link
            className=" btn btn-link  d-flex align-items-center"
            to="/category/recomanded-courses"
          >
            View all <FiChevronRight />
          </Link> */}
            </div>
            <div className="bg-white wrapper">
              <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
                {props.followingPlaylist.map((item, i) => (
                  <PlaylistCard item={item} key={i} />
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  playlist: state.playlist.playlist,
  followingPlaylist: state.playlist.followingPlaylist,
});

export default connect(mapStateToProps, {
  fetchPlaylist,
  fetchFollowingPlaylist,
})(Dashboard);
